// @flow

import React from 'react';
import qs from 'qs';
import ReactPaginate from 'react-paginate';
import { isBrowser } from 'react-device-detect';
import { scrollToEl } from 'core/config';

type Props = {
  pageCount: number,
  perPage: number,
  handlePageClick: any,
  forcePage: number
};

const Pagination = ({ pageCount, perPage, handlePageClick, forcePage }: Props) => {
  const pageRange = isBrowser ? 3 : 1;
  const { pathname } = window.location;
  const search = qs.parse(window.location.search, { ignoreQueryPrefix: true });

  const fixScrollingOnLoadingForIosMobile = () => {
    if (scrollToEl) scrollToEl.style.minHeight = `${scrollToEl.offsetHeight}px`;
  };

  const onPageClick = ({ selected }) => {
    handlePageClick(+selected + 1);
    fixScrollingOnLoadingForIosMobile();
    window.scrollTo({
      left: 0,
      top: +scrollToEl.offsetTop - +scrollToEl.dataset.offset
    });
  };

  return (
    Math.floor(pageCount/perPage) > 0 && <div className="pagination__wrap">
      <ReactPaginate
        hrefAllControls
        pageCount={Math.ceil(pageCount/perPage)}
        pageRangeDisplayed={pageRange}
        forcePage={forcePage}
        marginPagesDisplayed={1}
        onPageChange={e => onPageClick(e)}
        activeClassName="active"
        previousLabel="<"
        nextLabel=">"
        containerClassName='pagination'
        hrefBuilder={(page, pagesCount) =>
          page >= 1 && page <= pagesCount ? `${pathname}?${qs.stringify({ ...search, page })}` : '#'
        }
      />
    </div>
  );
};

export default Pagination;
